import clsx from 'clsx'
import React from 'react'

const Spinner = ({ className }) => (
  <svg
    className={clsx(
      'animate-spin -ml-1 mr-3',
      { 'h-7 w-7 text-gray-800': !className },
      className
    )}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-50"
      cx={12}
      cy={12}
      r="11.5"
      stroke="currentColor"
      strokeWidth="1"
    />
    <path
      className="opacity-100"
      stroke="currentColor"
      d="M12 23.5C13.5102 23.5 15.0056 23.2025 16.4009 22.6246C17.7961 22.0467 19.0639 21.1996 20.1317 20.1317C21.1996 19.0639 22.0467 17.7961 22.6246 16.4009C23.2025 15.0056 23.5 13.5102 23.5 12"
    />
  </svg>
)

export default Spinner
